import React from "react";

const ClarificationIcon = (props) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50001 10C1.30339 10 0.333344 9.02993 0.333344 7.83333V2.16667C0.333344 0.970047 1.30339 0 2.50001 0H11.5C12.6966 0 13.6667 0.970047 13.6667 2.16667V7.83333C13.6667 9.02993 12.6966 10 11.5 10H7.67501L4.33246 12.5005C3.96391 12.7761 3.44168 12.7008 3.16602 12.3323C3.05825 12.1881 3.00001 12.0131 3.00001 11.8333L2.99948 10H2.50001ZM7.34234 9H11.5C12.1443 9 12.6667 8.47767 12.6667 7.83333V2.16667C12.6667 1.52233 12.1443 1 11.5 1H2.50001C1.85568 1 1.33334 1.52233 1.33334 2.16667V7.83333C1.33334 8.47767 1.85568 9 2.50001 9H3.9992L3.99934 9.49987L3.99992 11.5004L7.34234 9Z"
        fill="#212121"
      />
    </svg>
  );
};

export default ClarificationIcon;
